var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","content-class":"dialog sm"}},[(_vm.show)?_c('exception-counts-by-level-chart',[_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.preventDefault();return _vm.hide.apply(null, arguments)}}},[_vm._v("Close")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }